const div = document.createElement("div");
div.setAttribute("contenteditable", "plaintext-only");
const result = div.contentEditable;
export const isPlainTextOnlySupported = result === "plaintext-only";
